const t = { step: "Шаг {{current}} из {{max}}. {{name}}", title: { first: "Ваш автомобиль", second: "Ваш автомобиль", third: "Параметры автомобиля", fourth: "Параметры автомобиля", success: "Расчет стоимости" } }, e = { title: "Увы, не удалось произвести расчет", description: "К сожалению, мы не смогли найти результаты, соответствующие всем выбранным вами критериям. Попробуйте изменить некоторые параметры.", noEstimate: { title: "Нет оценки", description: "Для редких, битых и новых машин не получится посчитать рыночную цену." }, startAgain: "Начать заново" }, s = { goTo: "Заполнить параметры вручную", back: "Назад", forward: { default: "Продолжить", byStage: { third: "Рассчитать стоимость", fourth: "Рассчитать стоимость" } } }, r = { estimatedPrice: { title: "Расчетная стоимость выкупа", noData: "Нет данных" }, save: "Сохранить результат", reset: "Начать заново" }, a = { errors: { required: "Поле обязательно для заполнения", incorrect: "Некорректное значение", emptyListValues: "Не удалось получить список значений" } }, o = {
  stageHeader: t,
  errorStage: e,
  stage: s,
  successStage: r,
  field: a
};
export {
  o as default,
  e as errorStage,
  a as field,
  s as stage,
  t as stageHeader,
  r as successStage
};
